import React from 'react';
import { Handle, Position } from 'reactflow';
import { MailOutlined, ExportOutlined, RobotOutlined, BulbOutlined } from '@ant-design/icons';

const OutputNode = ({ data, selected }) => {
  // Check if the output is configured
  const isConfigured = !!(data.config?.outputType && 
    ((data.config.outputType === 'analysis' || data.config.outputType === 'both') && data.config.analysisPrompt) ||
    ((data.config.outputType === 'export' || data.config.outputType === 'both')));
  
  // Determine colors based on configuration status
  const nodeColor = isConfigured ? '#722ed1' : '#d9d9d9';
  const iconColor = isConfigured ? '#722ed1' : '#999';
  const textColor = isConfigured ? '#333' : '#999';
  
  // Get display information
  const getDisplayName = () => {
    if (!data.config?.outputType) {
      return 'Output';
    }
    
    switch (data.config.outputType) {
      case 'analysis':
        return 'AI Analysis';
      case 'export':
        return 'Data Export';
      case 'both':
        return 'Analysis + Export';
      default:
        return 'Output';
    }
  };
  
  const getOutputIcon = () => {
    if (!data.config?.outputType) {
      return <ExportOutlined style={{ fontSize: '16px', color: iconColor }} />;
    }
    
    switch (data.config.outputType) {
      case 'analysis':
        return <RobotOutlined style={{ fontSize: '16px', color: iconColor }} />;
      case 'export':
        return <ExportOutlined style={{ fontSize: '16px', color: iconColor }} />;
      case 'both':
        return <BulbOutlined style={{ fontSize: '16px', color: iconColor }} />;
      default:
        return <ExportOutlined style={{ fontSize: '16px', color: iconColor }} />;
    }
  };
  
  const getConfigInfo = () => {
    if (!data.config?.outputType) {
      return isConfigured ? 'Configured' : 'Not configured';
    }
    
    const parts = [];
    
    if (data.config.outputType === 'analysis' || data.config.outputType === 'both') {
      if (data.config.analysisPrompt) {
        parts.push('AI Analysis');
      }
    }
    
    if (data.config.outputType === 'export' || data.config.outputType === 'both') {
      parts.push('Export');
      if (data.config.enableEmailNotification && data.config.emailAddress) {
        parts.push(`Email: ${data.config.emailAddress}`);
      }
    }
    
    return parts.length > 0 ? parts.join(', ') : 'Not configured';
  };

  return (
    <div className={`react-flow__node-output ${selected ? 'selected' : ''}`}
         style={{
           borderColor: nodeColor,
           backgroundColor: isConfigured ? 'white' : '#f5f5f5',
           opacity: isConfigured ? 1 : 0.7
         }}>
      <Handle
        type="target"
        position={Position.Left}
        style={{
          background: nodeColor,
          border: '2px solid #fff',
          width: '8px',
          height: '8px'
        }}
      />
      
      <div style={{ 
        padding: '12px', 
        display: 'flex', 
        alignItems: 'center', 
        gap: '8px',
        minWidth: '140px'
      }}>
        {getOutputIcon()}
        <div>
          <div style={{ 
            fontWeight: '500', 
            fontSize: '13px',
            color: textColor
          }}>
            {getDisplayName()}
          </div>
          <div style={{ 
            fontSize: '11px', 
            color: isConfigured ? '#666' : '#999',
            fontStyle: isConfigured ? 'normal' : 'italic',
            maxWidth: '180px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}>
            {getConfigInfo()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OutputNode;